import axioInstance from "../../custom_utilities/AxiosInstance/axiosInstance";

const BASE_ANALYTICS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/getAnalyticsReport";

const PRACTICE_SOLUTION_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/practise_solution";

const TOPIC_WISE_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/topicWiseComparison";

const SUBJECT_WISE_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/subjectWiseAnalysis";

const OVERALL_ANALYTICS_URL =
  "https://learning.motion.ac.in/motioneducation/api/v1/getoverallAnalyticsReport";

const QUESTION_ANALYSIS =
  "https://learning.motion.ac.in/motioneducation/api/v1/questionAnalysis";

const analyticsApi = {
  getBasicAnalytics: async ({ paperId, paperType }) => {
    const res = await axioInstance.get(
      `${BASE_ANALYTICS_URL}?paper_type=${paperType}&paper_id=${paperId}`
    );
    return res.data;
  },

  getPracticeSolution: async ({ paperId, testId, paperType }) => {
    const res = await axioInstance.get(
      `${PRACTICE_SOLUTION_URL}?paper_id=${paperId}&test_id=${testId}&paper_type=${paperType}`
    );
    return res.data;
  },

  getTopicWiseComparison: async ({ paperId, paperType }) => {
    const res = await axioInstance.get(
      `${TOPIC_WISE_URL}?paper_type=${paperType}&paper_id=${paperId}`
    );
    return res.data;
  },

  getSubjectWiseComparison: async ({ paperId, paperType }) => {
    const res = await axioInstance.get(
      `${SUBJECT_WISE_URL}?paper_type=${paperType}&paper_id=${paperId}`
    );
    return res.data;
  },

  getOverallAnalytics: async ({ paperId, paperType, filter_by }) => {
    const res = await axioInstance.get(
      `${OVERALL_ANALYTICS_URL}?paper_type=${paperType}&paper_id=${paperId}&filter_by=${filter_by}`
    );
    return res.data;
  },

  getQuestionAnalytics: async ({ paperId, paperType, qid }) => {
    const res = await axioInstance.get(
      `${QUESTION_ANALYSIS}?paper_type=${paperType}&paper_id=${paperId}&qid=${qid}`
    );
    return res.data;
  },
};

export default analyticsApi;
